import request from '@/request'

export function getChatList() {
    return request({
        url: `/onlineSerData/getChatList`,
        method: 'get'
    })
}

export function getChatHistoryByChatId(chatId) {
    return request({
        url: `/onlineSerData/getChatHistoryByChatId?chatId=${chatId}`,
        method: 'get'
    })
}

export function checkKefuExist() {
    return request({
        url: `/onlineSerData/checkKefuExist`,
        method: 'get'
    })
}



// WEBPACK FOOTER //
// ./src/api/onlineSer.js